var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDinersClub = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 20,
    viewBox: "0 0 32 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 19,
    rx: 3.5,
    fill: "white",
    stroke: "#E0E6EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8868 3.67122V3.6543H18.1174V3.67122C21.4335 3.91388 24 6.67509 24 10.0001C24 13.3251 21.4335 16.0863 18.1174 16.329V16.3459H13.8868V16.329C10.5707 16.0863 8.00415 13.3251 8.00415 10.0001C8.00415 6.67509 10.5707 3.91388 13.8868 3.67122Z",
    fill: "#0165AC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5792 13.5874C17.0972 13.0477 18.1112 11.611 18.1112 9.99994C18.1112 8.38885 17.0972 6.95214 15.5792 6.41245V13.5874ZM13.0408 6.41245C11.5228 6.95214 10.5088 8.38885 10.5088 9.99994C10.5088 11.611 11.5228 13.0477 13.0408 13.5874V6.41245ZM14.31 15.4996C11.2726 15.4996 8.8103 13.0373 8.8103 9.99994C8.8103 6.96254 11.2726 4.50024 14.31 4.50024C17.3474 4.50024 19.8097 6.96254 19.8097 9.99994C19.8097 13.0373 17.3474 15.4996 14.31 15.4996Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDinersClub);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/DinersClub.11d85b47c175e4636b313b3ef252067e.svg";